import { PaginatedResponse } from '@arpeggi/shared'
import { RawAxiosRequestHeaders } from 'axios'

interface CommonApiArgs {
  [key: string]: any
  headers?: RawAxiosRequestHeaders
}

export interface AbstractApi<T> {
  getOne?(args: CommonApiArgs): Promise<T>
  getMany?(args: CommonApiArgs): Promise<PaginatedResponse<T>>
  post?(args?: CommonApiArgs): Promise<T | void>
  update?(args: CommonApiArgs): Promise<T | void>
  delete?(args?: CommonApiArgs): Promise<void>
  getAll?(args?: CommonApiArgs): Promise<T[]>
}

export abstract class AbstractApi<T> {
  constructor(protected urlPrefix: string) {}
}
